import "core-js/modules/es.array.reverse.js";
const _excluded = ["items"];
var _class;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable } from "mobx";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import { isJsonObject } from "../../Core/Json";
import Result from "../../Core/Result";
import TerriaError from "../../Core/TerriaError";
import isDefined from "../../Core/isDefined";
import MappableMixin from "../../ModelMixins/MappableMixin";
import ModelReference from "../../Traits/ModelReference";
import { BaseMapTraits, BaseMapsTraits } from "../../Traits/TraitsClasses/BaseMapTraits";
import BingMapsCatalogItem from "../Catalog/CatalogItems/BingMapsCatalogItem";
import CommonStrata from "../Definition/CommonStrata";
import CreateModel from "../Definition/CreateModel";
import { BaseModel } from "../Definition/Model";
import updateModelFromJson from "../Definition/updateModelFromJson";
import { defaultBaseMaps } from "./defaultBaseMaps";
export class BaseMapModel extends CreateModel(BaseMapTraits) {}
export let BaseMapsModel = (_class = class BaseMapsModel extends CreateModel(BaseMapsTraits) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }

  /**
   * List of the basemaps to show in setting panel
   */
  get baseMapItems() {
    var _this$enabledBaseMaps, _this$enabledBaseMaps2;
    const enabledBaseMaps = [];
    const baseMapItems = (_this$enabledBaseMaps = (_this$enabledBaseMaps2 = this.enabledBaseMaps) === null || _this$enabledBaseMaps2 === void 0 ? void 0 : _this$enabledBaseMaps2.map(enabledBaseMapId => {
      return this.items.find(item => item.item === enabledBaseMapId);
    }).filter(isDefined)) !== null && _this$enabledBaseMaps !== void 0 ? _this$enabledBaseMaps : this.items;
    baseMapItems.forEach(baseMapItem => {
      if (baseMapItem.item && !ModelReference.isRemoved(baseMapItem.item)) {
        const itemModel = this.terria.getModelById(BaseModel, baseMapItem.item);
        if (MappableMixin.isMixedInto(itemModel)) {
          enabledBaseMaps.push({
            image: baseMapItem.image,
            contrastColor: baseMapItem.contrastColor,
            backgroundColor: baseMapItem.backgroundColor,
            item: itemModel
          });
        }
      }
    });
    return enabledBaseMaps;
  }

  // Can't do this in constructor since {@link CatalogMemberFactory} doesn't
  // have any values at the moment of initializing Terria class.
  initializeDefaultBaseMaps() {
    return this.loadFromJson(CommonStrata.definition, {
      items: defaultBaseMaps(this.terria)
    });
  }
  add(stratumId, baseMap) {
    if (baseMap.item === undefined) {
      throw new DeveloperError("A model without a `uniqueId` cannot be added to a group.");
    }
    const resolvedItem = this.terria.getModelById(BaseModel, baseMap.item);
    if (resolvedItem instanceof BingMapsCatalogItem) {
      addBingMapsKey(resolvedItem, this.terria);
    }
    const items = this.getTrait(stratumId, "items");
    if (isDefined(items)) {
      items.push(baseMap);
    } else {
      this.setTrait(stratumId, "items", [baseMap]);
    }
  }
  loadFromJson(stratumId, newBaseMaps) {
    const errors = [];
    const {
        items
      } = newBaseMaps,
      rest = _objectWithoutProperties(newBaseMaps, _excluded);
    if (items !== undefined) {
      var _newItemsIds$pushErro;
      const {
        items: itemsTrait
      } = this.traits;
      const newItemsIds = itemsTrait.fromJson(this, stratumId, items);
      (_newItemsIds$pushErro = newItemsIds.pushErrorTo(errors)) === null || _newItemsIds$pushErro === void 0 || _newItemsIds$pushErro.forEach((member, i) => {
        const existingItem = this.items.find(baseMap => baseMap.item === member.item);
        if (existingItem) {
          // object array trait doesn't automatically update model item
          updateModelFromJson(existingItem, stratumId, items[i]);
        } else {
          this.add(stratumId, member);
        }
      });
    }
    if (isJsonObject(rest)) updateModelFromJson(this, stratumId, rest).pushErrorTo(errors);else errors.push(TerriaError.from("Invalid JSON object"));
    return new Result(undefined, TerriaError.combine(errors, "Failed to add members from JSON for model `".concat(this.uniqueId, "`")));
  }
}, _applyDecoratedDescriptor(_class.prototype, "baseMapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseMapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadFromJson", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadFromJson"), _class.prototype), _class);
function addBingMapsKey(item, terria) {
  if (!item.key) {
    item.setTrait(CommonStrata.defaults, "key", terria.configParameters.bingMapsKey);
  }
}